"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ArticleVersions", {
  enumerable: true,
  get: function get() {
    return _ArticleVersions.default;
  }
});
exports.default = void 0;

var _ArticleVersions = _interopRequireDefault(require("./ArticleVersions"));

var _default = _ArticleVersions.default;
exports.default = _default;